<div class="pageContent">
  <h1>Thank you!</h1>
  <p>Your message has been sent.</p>
  <p>
    You can expect to hear back from us as soon as possible<br />
    if your enquiry requires a response.
  </p>
  <p><a [routerLink]="['/']">*Click here to return to homepage*</a></p>
</div>
